import { Typography, Box } from "@mui/material";
import { useState, useMemo, useEffect } from "react";
import { useInput } from '../hooks/useInput';
import keplr from "../images/keplr.png";
import metamask from "../images/metamask.png";
import evm from "../images/evm.png";
import six from "../images/six.png";
import BoxStyle from "./BoxStyle";
import SelectToken from "./SelectToken";
import MetaMaskFromToBox from "./MetamaskFromToBox";
import KeplrFromToBox from "./KeplrFromToBox";
import WhiteGradientButton from "./WhiteGradientButton";

const FormBox = ({
  from,
  setFrom,
  to,
  setTo,
  evmcanFetch,
  evmsetCanFetch,
  evmloading,
  evmsetLoading,
  evmbalance,
  evmsetBalance,
  evmestimateGas,
  evmsetEstimateGas,
  evmconnected,
  evmsetConnected,
  evmaccount,
  evmsetAccount,
  evmweb3,
  evmsetWeb3,
  protocolcanFetch,
  protocolsetCanFetch,
  protocolloading,
  protocolsetLoading,
  protocolbalance,
  protocolsetBalance,
  protocolestimateGas,
  protocolsetEstimateGas,
  protocolconnected,
  protocolsetConnected,
  protocolaccount,
  protocolsetAccount,
  useCustomToAddress,
  setUseCustomToAddress,
  customToAddress,
  setCustomToAddress,
  toloading,
  tosetLoading,
  tobalance,
  tosetBalance,
  onNext
}) => {
  const { input, setInput } = useInput();
  const [evmError, setEvmError] = useState(null);
  const [protocolError, setProtocolError] = useState(null);
  const [autoConnectWallet, setAutoConnectWallet] = useState(null);

  const fromMetaMask = useMemo(() => {
    return from.name === "SIX Protocol - EVM";
  }, [from]);

  const toMetaMask = useMemo(() => {
    return to.name === "SIX Protocol - EVM";
  }, [to]);

  // Real-time address validation
  const evmAddressRegex = /^0x[0-9a-fA-F]{40}$/;
  const cosmosAddressRegex = /^6x[a-z0-9]{38,}$/;
  const isAddressValid = useMemo(() => {
    if (!customToAddress) return false;
    if (fromMetaMask) return cosmosAddressRegex.test(customToAddress);
    return evmAddressRegex.test(customToAddress);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customToAddress, fromMetaMask]);

  // Show address error in real-time as user types
  useEffect(() => {
    if (!customToAddress) {
      setProtocolError(null);
      setEvmError(null);
      return;
    }
    if (fromMetaMask) {
      if (!cosmosAddressRegex.test(customToAddress)) {
        setProtocolError("Invalid SIX Protocol address (must start with '6x')");
      } else {
        setProtocolError(null);
      }
    } else {
      if (!evmAddressRegex.test(customToAddress)) {
        setEvmError("Invalid EVM address (must be '0x' + 40 hex chars)");
      } else {
        setEvmError(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customToAddress, fromMetaMask]);

  const handleFromChainChange = (e) => {
    if (e.target.value === "SIX Protocol - EVM") {
      setFrom({ img: six, sign: evm, name: "SIX Protocol - EVM" });
    } else {
      setFrom({ img: six, name: "SIX Protocol" });
    }
    setInput("0");
  };

  const topConnectOptions = useMemo(() => {
    const handleConnectMetamask = () => {
      if (!fromMetaMask) {
        setFrom({ img: six, sign: evm, name: "SIX Protocol - EVM" });
        setInput("0");
        setEvmError(null);
        setProtocolError(null);
        setCustomToAddress("");
      }
      setAutoConnectWallet('evm');
    };

    const handleConnectKeplr = () => {
      if (fromMetaMask) {
        setFrom({ img: six, name: "SIX Protocol" });
        setInput("0");
        setEvmError(null);
        setProtocolError(null);
        setCustomToAddress("");
      }
      setAutoConnectWallet('protocol');
    };

    return [
      { name: "MetaMask", img: metamask, onClick: handleConnectMetamask },
      { name: "Keplr", img: keplr, onClick: handleConnectKeplr }
    ];
  }, [fromMetaMask, setFrom, setInput, setCustomToAddress]);


  const renderTopBox = () => {
    if (fromMetaMask) {
      return (
        <MetaMaskFromToBox
          canFetch={evmcanFetch}
          setCanFetch={evmsetCanFetch}
          title="From:"
          chain={from}
          from={from}
          to={to}
          setTo={setTo}
          setFrom={setFrom}
          onChangeChain={handleFromChainChange}
          input={input}
          setInput={setInput}
          loading={evmloading}
          setLoading={evmsetLoading}
          balance={evmbalance}
          setBalance={evmsetBalance}
          estimateGas={evmestimateGas}
          setEstimateGas={evmsetEstimateGas}
          connected={evmconnected}
          setConnected={evmsetConnected}
          account={evmaccount}
          setAccount={evmsetAccount}
          web3={evmweb3}
          setWeb3={evmsetWeb3}
          disabled={false}
          alert={evmError}
          setAlert={setEvmError}
          inputDisabled={!evmconnected}
          customToAddress={customToAddress}
          setCustomToAddress={setCustomToAddress}
          autoConnectWallet={autoConnectWallet}
          setAutoConnectWallet={setAutoConnectWallet}
          connectOptions={topConnectOptions}
        />
      );
    } else {
      return (
        <KeplrFromToBox
          canFetch={protocolcanFetch}
          setCanFetch={protocolsetCanFetch}
          title="From:"
          chain={from}
          from={from}
          to={to}
          setTo={setTo}
          setFrom={setFrom}
          onChangeChain={handleFromChainChange}
          input={input}
          setInput={setInput}
          loading={protocolloading}
          setLoading={protocolsetLoading}
          balance={protocolbalance}
          setBalance={protocolsetBalance}
          estimateGas={protocolestimateGas}
          setEstimateGas={protocolsetEstimateGas}
          connected={protocolconnected}
          setConnected={protocolsetConnected}
          account={protocolaccount}
          setAccount={protocolsetAccount}
          disabled={false}
          alert={protocolError}
          setAlert={setProtocolError}
          inputDisabled={!protocolconnected}
          customToAddress={customToAddress}
          setCustomToAddress={setCustomToAddress}
          autoConnectWallet={autoConnectWallet}
          setAutoConnectWallet={setAutoConnectWallet}
          connectOptions={topConnectOptions}
        />
      );
    }
  };

  const renderBottomBox = () => {
    if (toMetaMask) {
      return (
        <MetaMaskFromToBox
          canFetch={evmcanFetch}
          setCanFetch={evmsetCanFetch}
          title="To:"
          chain={to}
          from={from}
          to={to}
          setTo={setTo}
          setFrom={setFrom}
          onChangeChain={handleFromChainChange}
          input={input}
          setInput={setInput}
          loading={toloading}
          setLoading={tosetLoading}
          balance={tobalance}
          setBalance={tosetBalance}
          estimateGas={evmestimateGas}
          setEstimateGas={evmsetEstimateGas}
          connected={evmconnected}
          setConnected={evmsetConnected}
          account={evmaccount}
          setAccount={evmsetAccount}
          web3={evmweb3}
          setWeb3={evmsetWeb3}
          disabled={true}
          alert={evmError}
          setAlert={setEvmError}
          inputDisabled={true}
          customToAddress={customToAddress}
          setCustomToAddress={setCustomToAddress}
          autoConnectWallet={autoConnectWallet}
          setAutoConnectWallet={setAutoConnectWallet}
          connectOptions={topConnectOptions}
        />
      );
    } else {
      return (
        <KeplrFromToBox
          canFetch={protocolcanFetch}
          setCanFetch={protocolsetCanFetch}
          title="To:"
          chain={to}
          from={from}
          to={to}
          setTo={setTo}
          setFrom={setFrom}
          onChangeChain={handleFromChainChange}
          input={input}
          setInput={setInput}
          loading={toloading}
          setLoading={tosetLoading}
          balance={tobalance}
          setBalance={tosetBalance}
          estimateGas={protocolestimateGas}
          setEstimateGas={protocolsetEstimateGas}
          connected={protocolconnected}
          setConnected={protocolsetConnected}
          account={protocolaccount}
          setAccount={protocolsetAccount}
          disabled={true}
          alert={protocolError}
          setAlert={setProtocolError}
          inputDisabled={true}
          customToAddress={customToAddress}
          setCustomToAddress={setCustomToAddress}
          autoConnectWallet={autoConnectWallet}
          setAutoConnectWallet={setAutoConnectWallet}
          connectOptions={topConnectOptions}
        />
      );
    }
  };



  const handleNext = () => {
    if (fromMetaMask) {
      if (!evmconnected) {
        setEvmError("Please connect your Metamask wallet to continue");
        return false;
      }
      if (!customToAddress) {
        setProtocolError("Please enter a destination address");
        return false;
      }
      if (!customToAddress.startsWith("6x") || customToAddress.length < 10) {
        setProtocolError("Invalid SIX Protocol address. Must start with '6x'");
        return false;
      }
    } else {
      if (!protocolconnected) {
        setProtocolError("Please connect your Keplr wallet to continue");
        return false;
      }
      if (!customToAddress) {
        setEvmError("Please enter a destination address");
        return false;
      }
      const evmAddressRegex = /^0x[0-9a-fA-F]{40}$/;
      if (!evmAddressRegex.test(customToAddress)) {
        setEvmError("Invalid EVM address. Must be '0x' followed by 40 hex characters");
        return false;
      }
    }
    const num = parseFloat(input);
    if (isNaN(num) || num <= 0) {
      if (fromMetaMask) {
        setEvmError("Amount can not be blanked");
      } else {
        setProtocolError("Amount can not be blanked");
      }
      return false;
    }
    setEvmError(null);
    setProtocolError(null);
    onNext();
  };

  return (
    <BoxStyle>
      <Typography variant="h5" align="center" textTransform="capitalize" mb={1}>
        Token transfer
      </Typography>
      <SelectToken value="SIX" />

      {renderTopBox()}

      <Box display="flex" justifyContent="center" alignItems="center" sx={{ my: 1.5 }}>
        <span className="material-symbols-rounded" style={{ fontSize: "32px", color: "rgba(255,255,255,0.7)" }}>
          arrow_downward
        </span>
      </Box>

      {renderBottomBox()}

      <WhiteGradientButton
        onClick={handleNext}
        sx={{ mt: 3 }}
        disabled={
          fromMetaMask
            ? (!evmconnected || !isAddressValid)
            : (!protocolconnected || !isAddressValid)
        }
      >
        Next
      </WhiteGradientButton>
    </BoxStyle>
  );
};

export default FormBox;
